import EnglishFlag from "@assets/images/language_flags/english.svg";
import FrenchFlag from "@assets/images/language_flags/french.svg";
import ButtonVariants from "@core-components/button/ButtonVariants";
import { ELanguage, type Language } from "@helpers/I18nHelper";
import useAppLanguage from "@hooks/language/useAppLanguage";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Image, Menu } from "@mantine/core";

interface LanguageButtonProps {
  flagSrc: string;
  altText: string;
  languageLabel: string;
  languageCode: Language;
}

const LanguageSwitcher: React.FC = () => {
  const { t } = useAppTranslation("common.languages");
  const { changeLanguage, lang } = useAppLanguage();

  const LanguageButton = ({
    altText,
    flagSrc,
    languageLabel,
    languageCode,
  }: LanguageButtonProps) => {
    return (
      <Menu.Item
        leftSection={<Image src={flagSrc} alt={altText} className="size-6" />}
        className={
          "w-full bg-transparent font-inter font-normal text-white hover:bg-slate-200/20"
        }
        onClick={() => {
          changeLanguage(languageCode);
        }}
      >
        {languageLabel}
      </Menu.Item>
    );
  };

  return (
    <Menu
      shadow="md"
      transitionProps={{ duration: 300, transition: "fade-down" }}
      trigger="click-hover"
    >
      <Menu.Target>
        <ButtonVariants.ActionIcon>
          <Image
            src={
              lang.currentLanguage === ELanguage.en ? EnglishFlag : FrenchFlag
            }
            alt={
              lang.currentLanguage === ELanguage.en ? t("english") : t("french")
            }
            className="size-6"
          />
        </ButtonVariants.ActionIcon>
      </Menu.Target>
      <Menu.Dropdown className="rounded-md border-2 border-primary-light bg-primary-light p-2">
        <LanguageButton
          flagSrc={FrenchFlag}
          altText={t("french")}
          languageLabel={t("french")}
          languageCode={ELanguage.fr}
        />
        <Menu.Divider className="my-2" />
        <LanguageButton
          flagSrc={EnglishFlag}
          altText={t("english")}
          languageLabel={t("english")}
          languageCode={ELanguage.en}
        />
      </Menu.Dropdown>
    </Menu>
  );
};

export default LanguageSwitcher;
